import { c as _c } from "react/compiler-runtime";
import { HomeRedirect } from '#components/common/HomeRedirect';
import { ShowIfLoggedIn } from '#components/common/ShowIfLoggedIn';
const ProtectedHomePage = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ShowIfLoggedIn><HomeRedirect /></ShowIfLoggedIn>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default ProtectedHomePage;